// Money as the payment tables show it. Our checkouts are priced in USD;
// Stripe offers customers their local currency on its own checkout page
// (Adaptive Pricing), so rows are USD, but older ones may be in another
// currency - always format with the row's own currency.

/** "USD $15.00" / "INR ₹1,299.00" (payment history tables and exports). */
export const formatMoneyWithCode = (amount: number | string | null | undefined, currency?: string | null) => {
    const code = (currency || "USD").toUpperCase();
    const value = Number(amount) || 0;
    try {
        const text = new Intl.NumberFormat(code === "INR" ? "en-IN" : "en-US", {
            style: "currency",
            currency: code,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
        return `${code} ${text}`;
    } catch {
        return `${code} ${value.toFixed(2)}`;
    }
};
